import * as React from 'react'
import { CheckinJointReviewReminderNotification } from '../../../../store/modules/notifications'
import { FormattedDateTime } from 'components/formatted-datetime'

export type CheckinJointReviewReminderProps = {
  notification: CheckinJointReviewReminderNotification
}

export const CheckinJointReviewReminderContent: React.VFC<
  CheckinJointReviewReminderProps
> = (props) => {
  const { notification } = props

  return (
    <div className="flex flex-col gap-y-0.5">
      <div>
        {"Don't forget to complete your Check-in with"}
        {notification.author && (
          <>
            {' '}
            <strong className="font-bold">
              {notification.author.fullName}
            </strong>
          </>
        )}{' '}
      </div>
      <div className="flex flex-row items-center justify-between gap-2 flex-wrap">
        <span className="text-theme-40">View Check-in</span>
        <FormattedDateTime
          className="text-gray-600 text-xs"
          date={notification.createdAt}
        />
      </div>
    </div>
  )
}
